import axios from 'axios'
import auth from '@/auth'
import router from '@/router'

const API_URL = process.env.API_URL

let registeredRequests = {}

let instance

export default {
  request (options) {
    let method = options && options.method
    let url = options && options.url
    let registerRequest = this.registerRequest
    options.cancelToken = new axios.CancelToken(function executor (c) {
      registerRequest(method, url, c)
    })
    return this.getInstance().request(options).then(response => {
      return response
    }).catch(error => {
      return Promise.reject(error)
    })
  },
  get (url, data = {}) {
    return this.request({
      method: 'get',
      url,
      params: data
    })
  },
  post (url, data = {}, headers = {}) {
    return this.request({
      method: 'post',
      url,
      data,
      headers: headers
    })
  },
  put (url, data = {}) {
    return this.request({
      method: 'put',
      url,
      data
    })
  },
  delete (url, data = {}) {
    return this.request({
      method: 'delete',
      url,
      data
    })
  },
  registerRequest (method, url, cancelToken) {
    if (typeof (registeredRequests[method]) === 'undefined') {
      registeredRequests[method] = {}
    }
    if (typeof (registeredRequests[method][url]) !== 'undefined') {
      let cancel = registeredRequests[method][url]
      cancel()
      delete registeredRequests[method][url]
    }
    registeredRequests[method][url] = cancelToken
  },
  getInstance () {
    if (instance) {
      return instance
    }

    instance = axios.create({
      baseURL: API_URL
    })
    instance.defaults.headers.common['Accept'] = 'application/json'
    instance.interceptors.request.use(async (config) => {
      if (auth.isAccessTokenExpired()) {
        if (auth.getRefreshToken()) {
          await auth.loadAccessToken().then(response => {
            let data = response.data
            if (data && data.access_token) {
              auth.setAccessTokenLoading(false)
              auth.login(data)
            }
          }).catch(error => {
            console.error(error)
            auth.setAccessTokenLoading(false)
            auth.logout()
            router.push('/login')
          })
        }
      }
      let token = auth.getAccessToken()
      if (token) {
        config.headers.Authorization = 'Bearer ' + token
      }
      return config
    })
    instance.interceptors.response.use(response => {
      return response
    }, error => {
      if (Object.getPrototypeOf(error) === axios.Cancel.prototype) {
        return new Promise(() => {})
      }
      let errors = [400]
      if (errors.indexOf(error.response.status) > -1) {
        auth.logout()
        router.push('/login')
      }
      return Promise.reject(error)
    })

    return instance
  }
}



// WEBPACK FOOTER //
// ./src/services/api.js